'use strict';

function roll() {
    var duration = 5000;
    if ($('[data-rolling-duration]')){
        try {
            duration = parseInt($('[data-rolling-duration]').attr('data-rolling-duration'));
        } catch (error) {
            duration = 5000;
        }
    }
    $('.rolling-header-text-wrapper .rolling-header-text').each(function () {
        $('.rolling-header-text-wrapper').delay(duration).animate({
            scrollTop: $(this).offset().top
        }, 1000);
    });
}

module.exports = function () {
    var lines = $('.rolling-header-text-wrapper .rolling-header-text');
    setInterval(roll, 100);
};
